import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=31bba490&scoped=true&"
import script from "./PhoneVerification.vue?vue&type=script&lang=js&"
export * from "./PhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerification.vue?vue&type=style&index=0&id=31bba490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bba490",
  null
  
)

export default component.exports